var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("app-browse", {
        ref: "browse",
        attrs: {
          "data-source": _vm.dataSource,
          "selected-items": _vm.selectedItems,
          "url-query-params": "",
          "delete-message-key":
            "components.diverse-ledgers.delete-warning-message",
        },
      }),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/diverse-ledgers",
            "full-height": "",
            "escape-close": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              refresh: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }